<template>
    <b-row>
        <b-card no-body
                class="flex-row w-100"
                header-class="p-0"
                header-tag="nav"
        >
            <template #header>
                <b-nav tabs vertical class="justify-content-start">
                    <b-nav-item v-for="(tab, key) in tabs"
                                :key="key"
                                :to="{name: tab.route}"
                                active-class="active"
                    >
                        <fa-icon :icon="tab.icon" />
                        {{ tab.name }}
                    </b-nav-item>
                </b-nav>
            </template>
            <template>
                <b-card-body>
                    <router-view :key="$route.fullPath" />
                </b-card-body>
            </template>
        </b-card>
    </b-row>
</template>

<script>
export default {
    name: 'Settings',

    loading: false,

    data() {
        return {
            tabs: [
                {
                    icon: 'user',
                    name: 'Profile',
                    route: 'settings.profile',
                },
                {
                    icon: 'lock',
                    name: 'Password',
                    route: 'settings.password',
                },
            ],
        };
    },
};
</script>

<style>
.card.flex-row {
    margin: 0 0.25rem;
}

nav.card-header {
    border-bottom: none;
    /* border-right: 1px solid #e8eced; */
    white-space: nowrap;
}

.nav-tabs.flex-column {
    /* border-bottom: none; */
    border-right: none;
    /* border-right: 1px solid #e8eced; */
}

.nav-tabs.flex-column .nav-link:not('active'){
    /* border-bottom: none; */
    /* border-right: none; */
    border-right: 1px solid #e8eced;
}

.nav-tabs.flex-column .nav-link:hover {
    /* border-bottom: none; */
    /* border-right: none; */
    border-color: #e9ecef #dee2e6 #e9ecef #e9ecef;
    /* border-color: #dee2e6 #e9ecef #dee2e6 #dee2e6; */
}

/* .nav-tabs.flex-column .nav-link { */
    /* border-radius: .25rem 0 0 .25rem; */
    /* border-right: none; */
/* } */

.nav-tabs.flex-column .nav-link.active {
    border-color: #e9ecef #dee2e6 #e9ecef #e9ecef;
    border-color:#dee2e6;
    border-right: none;
    border-radius: .25rem 0 0 .25rem;
}

</style>
